<div *ngIf="canAccess" class="relative dashboard-box lg:col-span-2 ">
  <div class="absolute inset-px rounded-[16px]"></div>
  <div class="relative flex h-full flex-col overflow-hidden rounded-[16px]">

    <!-- Mostrar saldo si hay owner -->
    <div *ngIf="owner && balanceAmount !== null" class="px-8 sm:px-10 py-4 flex justify-center">
      <div class="bg-white rounded-lg shadow p-4 flex items-center gap-4">
        <img class="rotate-minus12" width="112px" src="./assets/icons/card.svg" alt="card" />
         <img width="32" height="32" src="./assets/icons/call-white.svg" />
        <div>
          <div class="text-sm font-medium text-gray-600">Saldo del usuario</div>
          <div class="text-2xl font-bold text-green-600">{{ balanceAmount | number:'1.2-2' }} €</div>
        </div>
      </div>
    </div>


    <div class="py-1 flex justify-center dashboard-header">
      <h2 class="text-xl text-white font-semibold mb-0">Transacciones</h2>
    </div>
    <div class="@container relative min-h-[15rem] w-full grow max-lg:mx-auto max-lg:max-w-sm px-2 lg:px-8">
      <div class="flex mt-6 mb-6 inset-x-0 bottom-0">
        <div *ngIf="loadingTransactions" class="w-full text-center">
          <mat-spinner diameter="50" strokeWidth="3"></mat-spinner>
        </div>

        <app-generic-list class="w-full flex-col" *ngIf="transactionList.length > 0 && !loadingTransactions"
          filterKeyPrefix="transactions"
          [items]="transactionList"
          (itemClick)="onTransactionClick($event)"
          [filterFields]="filterTransactions"
          [showFilters]="true"
          [isFiltersCollapsed]="true"
          [allowDownload]="false"
          (filtersChanged)="onFiltersChanged($event)"
          (pageChanged)="loadMoreTransactions()"
          (filteredCount)="filteredCounts.transactionList = $event"
          [pageSize]="10">
          
          <ng-template #tableHeaderTemplate>
            <div class="grid grid-cols-6 gap-4 items-center border-b py-2 font-semibold text-sm text-gray-700">
              <div class="col-span-1 truncate">Amount € </div>
              <div class="col-span-1 truncate">Source</div>
              <div class="col-span-1 truncate">Destination</div>
              <div class="col-span-1 truncate">Phonenumber</div>
              <div class="col-span-1">Status</div>
              <div class="col-span-1">Fecha</div>
            </div>
          </ng-template>



          <ng-template #itemTemplate let-item>
            <div class="grid grid-cols-6 gap-4 items-center border-b py-2">
              <div class="col-span-1 truncate text-sm text-gray-500" title="{{ item.amount }}">{{ item.amount | number:'1.2-2' }} </div>
              <div class="col-span-1 truncate text-sm text-gray-500" title="{{ item.source }}">{{ item.source }}</div>
              <div class="col-span-1 truncate text-sm text-gray-500" title="{{ item.destination }}">{{ item.destination }}</div>
              <div class="col-span-1 truncate text-sm text-gray-500" title="{{ item.owner }}">{{ item.phonenumber }}</div>
              <div class="col-span-1 text-sm">{{ item.type }}</div>
              <div class="col-span-1 text-sm" *ngIf="item.createdAt">{{ item.createdAt | date:'dd/MM/yyyy HH:mm' }}</div>
            </div>
          </ng-template>

          <div *ngIf="filteredCounts.transactionList == 0 && !loadingTransactions" class="w-full content-center h-[200px]">
            <div class="!font-medium text-center">
              <mat-icon class="!text-[100px] !size-[100px]" style="color:#cfcfcf;">receipt_long</mat-icon><br />
              No se encontraron transacciones
            </div>
          </div>
        </app-generic-list>
      </div>
    </div>
  </div>
  <div class="pointer-events-none absolute inset-px rounded-lg ring-1 shadow-sm ring-black/5 lg:rounded-[2rem]"></div>
</div>